export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "harvested_package": {
            "number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total (Empaques)"])},
            "crop_har_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empaque"])}
          }
        }
      },
      "en": {
        "model": {
          "harvested_package": {
            "number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number"])},
            "crop_har_package": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Harvest package"])}
          }
        }
      }
    }
  })
}